<div class="modal-body">
  <div class="row">
    <h2>{{ 'brapi-sync.observation.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col">
      <app-collapsible [heading]="'brapi-sync.observation.connection-info' | translate">
        <div class="card">
          <div class="card-body">
            <h5><span class="badge badge-pill text-bg-success text-white">{{context.sourceStudy.studyName}}</span></h5>
          </div>
        </div>
      </app-collapsible>
      <app-collapsible [heading]="'brapi-sync.observation.observations' | translate">
        @if (loading) {
          <div class="row">
            <div class="col">
              <span class="throbber"></span>
            </div>
          </div>
        }
        @if (!loading) {
          <div class="row">
            <div class="col">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-curved">
                  <caption></caption>
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">{{ 'brapi-sync.observation.table.source-observation-variable-name' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation.table.target-observation-variable-name' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation.table.number-of-source-observations' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation.table.source-observations' | translate }}</th>
                      <th scope="col">{{ 'brapi-sync.observation.table.status' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (key of context.variablesMap | objectKeys; track key) {
                      <tr>
                        <td>{{key}}</td>
                        <td>{{context.variablesMap[key]?.observationVariableName}}</td>
                        <td>{{sourceObservationsByVariable[key]?.length}}</td>
                        <td><app-expandable-json-viewer [json]="sanitizeObject(sourceObservationsByVariable[key])"></app-expandable-json-viewer></td>
                        <td>
                          @if (isValidForImport(context.variablesMap[key])) {
                            <span><i class="fa fa-check text-success"></i></span>
                          }
                          @if (!isValidForImport(context.variablesMap[key])) {
                            <span><i class="fa fa-exclamation-triangle text-warning"></i> {{ 'brapi-sync.observation.status.already-exists' | translate }}</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      </app-collapsible>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary ms-2" (click)="post()" [disabled]="!isValid()">
    @if (isSaving) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import-observations' | translate }}
  </button>
</div>

<ng-template #downloadError>
    <div class="row">
        <div class="col">
            <span>{{'brapi-sync.germplasm.error.there-are-errors-during-import' | translate}} <a href="javascript:void(0)" (click)="downloadErrorsAndInfo()"> {{ 'brapi-sync.germplasm.error.download-details-here' | translate }}</a></span>
        </div>
    </div>
</ng-template>

